//=====================================================
//　カート関連処理
//  カート情報はセッションで管理
//=====================================================

import { IFCart } from "./CommonConst";

//--------------------------------------------------------
//セッションのカート情報にサービス・オプションを追加する
//IDが既に存在する場合は数を足す
//--------------------------------------------------------
export function addCart(params: IFCart[]){

    let tmpCart = getCart();

    //サービスの登録
    params.forEach(function(s_item){
        let sIdx = isExistID(s_item.service_id)[0];
        if (sIdx > -1){
            tmpCart[sIdx].service_count = tmpCart[sIdx].service_count + s_item.service_count;
            //オプションの登録
            s_item.option_list.forEach(function(o_item){
                let oIdx = isExistID(o_item.option_id)[1];
                if (oIdx > -1){
                    tmpCart[sIdx].option_list[oIdx].option_count += o_item.option_count;
                } else {
                    tmpCart[sIdx].option_list.push(o_item);
                }
            });
        } else {
            tmpCart.push(s_item);
        }
    });
    
    sessionStorage.setItem('cart', JSON.stringify(tmpCart));

}

//--------------------------------------------------------
//セッションのカート情報からサービス・オプションを削除する
//--------------------------------------------------------
export function removeCart(id: string){

    let tmpCart = getCart();

    let existIdx = isExistID(id);
    if (existIdx[0] !== -1 && existIdx[1] === -1){
        //カテゴリー削除の場合
        tmpCart.splice(existIdx[0], 1);
    } else if (existIdx[0] !== -1 && existIdx[1] !== -1) {
        //オプション削除の場合
        tmpCart[existIdx[0]].option_list.splice(existIdx[1], 1);
    }

    setCart(tmpCart);

}


//--------------------------------------------------------
//セッションのカート情報をすべて削除する
//--------------------------------------------------------
export function clearCart(){

    sessionStorage.removeItem('cart');

}


//--------------------------------------------------------
//セッションのカート情報を取得する
//--------------------------------------------------------
export function getCart(): IFCart[]{

    let tmpCart = sessionStorage.getItem('cart');

    if (!tmpCart){
        return [];
    } else {
        return JSON.parse(tmpCart);
    }

}

//--------------------------------------------------------
//セッションのカート情報をセットする（上書き）
//--------------------------------------------------------
export function setCart(params: IFCart[]){

    sessionStorage.setItem('cart', JSON.stringify(params));

}

//--------------------------------------------------------
//セッションのカート情報に同一IDが存在するか判定
//存在する場合、インデックスを返す（[カテゴリIDX、オプションIDX]）
//カテゴリIDの場合はオプションIDXは-1
//--------------------------------------------------------
export function isExistID(id: string): number[]{
    
    let tmpCart = getCart();
    let retIdx = [-1, -1];

    tmpCart.some(function(s_item, s_idx){

        //サービスIDの検索
        if (s_item.service_id === id){
            retIdx = [s_idx, -1];
            return true;
        }

        //オプションIDの検索
        s_item.option_list.some(function(o_item, o_idx){
            if (o_item.option_id === id){
                retIdx = [s_idx, o_idx];
                return true;
            }
        });

    });

    return retIdx;

}